import Glider from 'glider-js';

import './program';

(function () {
    'use strict';

    autoPlayYouTubeModal();
    speakerSlider();

    gravityformHook();

    // Lazy load background images
    var lazyBackgrounds = [].slice.call(document.querySelectorAll('.lazy-background'));
    if ('IntersectionObserver' in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function (lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    }
})();

function autoPlayYouTubeModal() {
    const triggerOpen = jQuery('body').find('[data-tagVideo]');
    triggerOpen.click(function () {
        const theModal = jQuery(this).data('bs-target');
        const videoSRC = jQuery(this).attr('data-tagVideo');
        jQuery(theModal + ' iframe').attr('src', videoSRC);
        jQuery(theModal + ' button.btn-close').click(function () {
            jQuery(theModal + ' iframe').attr('src', videoSRC);
        });
    });
}

function speakerSlider() {
    if (jQuery('.glider').length > 0) {
        new Glider(document.querySelector('.glider'), {
            slidesToScroll: 1,
            slidesToShow: 'auto',
            itemWidth: 138,
            draggable: false,
            scrollLock: true,
            rewind: true,
            exactWidth: true,
            arrows: {
                prev: '#glider-prev',
                next: '#glider-next'
            },
            responsive: [
                {
                    // screens greater than >= 992px
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 'auto',
                        slidesToScroll: 1,
                        itemWidth: 247
                    }
                },
                {
                    // screens greater than >= 1200px
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 'auto',
                        slidesToScroll: 1,
                        itemWidth: 330
                    }
                }
            ]
        });
    }
}

/*
Gravity Forms
*/
function gravityformHook() {
    const target = '.blk_form .gform_wrapper';

    if (jQuery(target).length > 0) {
        jQuery('.gform_button').removeAttr('onclick');

        jQuery(`${target} form input, ${target} form textarea`).on('focus', function () {
            jQuery(this).parents('.gfield').removeClass('invalid');
            jQuery(this).parents('.gfield').find('.field-message').remove();
        });

        jQuery(`${target} form`).on('submit', function (event) {
            const endpointUrl = jQuery(this)
                .parents('.blk_form')
                .attr('data-gf-url')
                .replace('=', '');
            const formId = jQuery(this).parents('.blk_form').attr('data-gf-id');
            const baseUrl = jQuery(this)
                .parents('.blk_form')
                .attr('data-gf-baseurl')
                .replace('=', '');

            event.preventDefault();

            // Get all data
            const data = {};
            const values = {};
            jQuery.each(jQuery(this).serializeArray(), function (i, field) {
                if (field.name.startsWith('input_')) {
                    values[field.name] = field.value;
                } else if (field.name === 'g-recaptcha-response') {
                    values[field.name] = field.value;
                }
            });
            data.baseUrl = baseUrl;
            data.payload = values;

            const json = JSON.stringify(data);

            const currentForm = jQuery(this);

            jQuery.ajax({
                method: 'POST',
                url: endpointUrl,
                data: json,
                contentType: 'application/json',
                beforeSend: function () {
                    // Show spinner
                    jQuery(currentForm).find('.gform_button').attr('disabled', 'disabled');
                    jQuery(currentForm).parents('.blk_form').addClass('loading');
                    jQuery(currentForm).parents('.blk_form').find('.form-messages').html('');
                },
                success: function (result) {
                    // Successful
                    if (result.status === 'success') {
                        if (formId === '3' || formId === '5') {
                            window.location.href = '/thank-you-sponsors';
                        } else {
                            window.location.href = '/thank-you';
                        }
                        // Errors
                    } else {
                        var messages = jQuery(currentForm)
                            .parents('.blk_form')
                            .find('.form-messages');
                        messages.html(
                            '<div class="error">Your submission contained the following errors: <ul class="errors"></ul></div>'
                        );

                        jQuery.each(result.validation_messages, function (i, e) {
                            const currentField = jQuery(currentForm).find(
                                '#field_' + formId + '_' + i
                            );
                            jQuery(currentField).addClass('invalid');
                            messages.find('.errors').append('<li>' + e + '</li>');
                        });

                        jQuery(currentForm).find('.gform_button').removeAttr('disabled');
                        jQuery(currentForm).parents('.blk_form').removeClass('loading');

                        if (grecaptcha !== undefined) {
                            grecaptcha.reset();
                        }
                    }
                },
                error: function () {
                    jQuery(currentForm)
                        .parents(target)
                        .find('.form-messages')
                        .html(
                            '<div class="error-message">There was an error sending message. Please try again later.</div>'
                        );
                    jQuery(currentForm).find('.gform_button').removeAttr('disabled');
                    jQuery(currentForm).parents('.blk_form').removeClass('loading');

                    setTimeout(function () {
                        jQuery(currentForm).parents(target).find('.form-messages').html('');
                    }, 30000);
                }
            });
        });
    }
}
